import { invokeAmTpDemoAiTask } from './invokeAmTpDemoAiTask';
import { TAmDemoAiContextFor } from './types';

/** Returns the candidate intercompany flows the ledger scan surfaces. */
export async function identifyAmTpDemoIntercompany(
  context: TAmDemoAiContextFor<'erp.identify-intercompany'>
) {
  return invokeAmTpDemoAiTask('erp.identify-intercompany', context);
}
